<template>
	<!-- 销售汇总 -->
	<div class="salesSummary">
		<div class="search">
			<div class="search-l">
				<div class="l-item" style="width: 40%;">
					<div class="item-label">下单时间</div>
					<div class="item-input" style="width: 80%;">
						<el-date-picker v-model="dateVal" type="datetimerange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']" style="width: 100%;">
						</el-date-picker>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">配货日期</div>
					<div class="item-input">
						<el-date-picker v-model="searchForm.date" type="date" value-format="yyyy-MM-dd"
							style="width: 100%;">
						</el-date-picker>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">配货仓库</div>
					<div class="item-input">
						<el-select v-model="searchForm.warehouse_id" placeholder="请选择">
							<el-option v-for="item in warehouseOptions" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">售后订单</div>
					<div class="item-input">
						<el-select v-model="searchForm.has_service" placeholder="请选择">
							<el-option v-for="item in hasServiceList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">商品状态</div>
					<div class="item-input">
						<el-select v-model="searchForm.status" placeholder="请选择">
							<el-option v-for="item in statusList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">商品分类</div>
					<div class="item-input">
						<el-select v-model="selectCate" multiple collapse-tags placeholder="请选择">
							<el-option v-for="item in cateList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">包含商品</div>
					<div class="item-input">
						<el-input v-model="searchForm.key" placeholder="请输入商品名称" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">联系人</div>
					<div class="item-input">
						<el-input v-model="searchForm.contacts" placeholder="请输入联系人" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">电话</div>
					<div class="item-input">
						<el-input v-model="searchForm.phone" placeholder="请输入电话" />
					</div>
				</div>
				<div class="l-item">
					<el-button type="warning" @click.stop="handleSearch">搜索</el-button>
					<el-button
						@click.stop="pageNum = 10, selectCate = [], searchForm = {}, searchForm.begin = dateVal[0], searchForm.end = dateVal[1], handleSearch()">重置</el-button>
				</div>
				<i></i>
				<i></i>
				<i></i>
				<i></i>
			</div>
		</div>
		<div class="table">
			<div class="table-operation">
				<el-button type="danger" @click.stop="handleDelay">改配货日期</el-button>
				<el-button type="success" @click.stop="handleExport">导出未配汇总</el-button>
				<el-button type="success" @click.stop="handleExportWarehouse">导出未配仓库明细</el-button>
				<div style="margin:0 10px;display: inline;">
					<el-dropdown @command="handleExportContacts">
						<el-button type="success">
							导出未配提货人明细<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>

						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">按提货人姓名排序</el-dropdown-item>
							<el-dropdown-item command="2">按手机后四位排序</el-dropdown-item>
						</el-dropdown-menu>

					</el-dropdown>
				</div>
				<el-button type="info" icon="el-icon-refresh-left" @click.stop="loading = true, getList()"></el-button>
			</div>

			<Table :data="tableData" :total="total" v-loading="loading"
				@size-change="pageNum = $event, loading = true, getList()"
				@current-change="page = $event, loading = true, getList()" @selection-change="selectionChange">
				<el-table-column type="selection" width="60"></el-table-column>
				<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
				<el-table-column prop="arrived_date" label="配货日期" align="center" width="140"></el-table-column>
				<el-table-column prop="created_at" label="下单时间" align="center" width="140"></el-table-column>
				<el-table-column label="提货人" align="center">
					<template slot-scope="scope">
						<p>{{scope.row.contacts}}</p>
						<p>{{scope.row.phone}}</p>
						<p>{{scope.row.address}}</p>
					</template>
				</el-table-column>
					<el-table-column  label="商品状态" align="center" width="120">
						<template slot-scope="scope">
							<p v-if="scope.row.status == 1">未锁单</p>
							<p v-if="scope.row.status == 2">已锁单</p>
							<p v-if="scope.row.status == 4" style="color:green">已核销</p>
						</template>
					</el-table-column>
				<el-table-column prop="category_title" label="商品分类" align="center" width="200"></el-table-column>
				<el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
				<el-table-column prop="goods_intro" label="商品卖点" align="center"></el-table-column>
				<el-table-column prop="attribute" label="自定义属性" align="center"></el-table-column>
				<el-table-column prop="count" label="订单数量" align="center"></el-table-column>
				<el-table-column prop="amount" label="订单金额" align="center"></el-table-column>
			</Table>
		</div>
		<!-- 延期 -->
		<el-dialog title="修改商品配货日期" :visible.sync="delayDialogVisible" :close-on-click-modal="false" v-el-drag-dialog
			width="30%">
			<el-form ref="form" :model="delayForm" label-width="100px">
				<el-form-item label="新日期">
					<el-date-picker v-model="delayForm.date" type="date" placeholder="选择配货日期" value-format="yyyy-MM-dd"
						style="width:100%">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="delayDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click.stop="delayConfirmFn">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getLodop
	} from '@/utils/CLodopfuncs.js'
	export default {
		data() {
			return {
				dateVal: [],
				searchForm: {
					begin: '',
					end: '',
					has_service: 0,
					cate_ids: ""
				},
				// 仓库
				warehouseOptions: [],
				tableData: [],
				loading: true,
				page: 1,
				pageNum: 10,
				total: 0,
				// 售后
				hasServiceList: [{
						id: 0,
						name: '不含售后'
					},
					{
						id: 1,
						name: '仅含售后'
					}
				],
				// 商品
				statusList: [{
						id: 1,
						name: '未核销'
					},
					{
						id: 4,
						name: '已核销'
					}
				],
				// 供应商信息
				supplier_info: {},
				currentDateTime: this.getCurrentDateTime(),
				cateList: [],
				selectCate: [],
				selectionList: [],
				delayForm: {},
				delayDialogVisible: false,
				batchDelayArr:[]
			}
		},
		mounted() {
			// 仓库
			this.getWarehouseList()
			// 时间
			this.dateVal = [this.getCurrentDate() + ' ' + '00:00:00', this.getCurrentDate() + ' ' + '23:59:59']
			this.searchForm.begin = this.dateVal[0]
			this.searchForm.end = this.dateVal[1]
			// 列表
			this.getList()
			this.supplier_info = JSON.parse(sessionStorage.getItem('supplier_info'))
			this.getCateList()
		},
		methods: {
			// 选择表格数据
			selectionChange(e) {
				this.selectionList = e
			},
			handleDelay() {
				if (this.selectionList.length <= 0) {
					this.$message.error('请选择数据');
					return
				}
				this.selectionList.forEach(item => {
					this.batchDelayArr.push(item.id)
				});
				this.delayForm.detail = this.batchDelayArr.join(",")
				this.delayDialogVisible = true
			},
			// 延期确认
			delayConfirmFn() {
				if (!this.delayForm.date || this.delayForm.date == ""){
					this.$message.error("请选择新的配货日期")
					return
				}
				let url = 'erp/v1/order/batch_goods_delay'
				this.$http.post(`${url}`, {
					...this.delayForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.$message.success("操作成功")
						this.delayDialogVisible = false
						this.getList()
					} else {
						this.$message.error(msg);
					}
				})
			},
			handleSearch() {
				this.page = 1
				this.searchForm.begin = this.dateVal[0]
				this.searchForm.end = this.dateVal[1]
				if (this.selectCate) {
					this.searchForm.cate_ids = this.selectCate.join(",")
				}
				this.getList()
				//window.localStorage.setItem("searchForm",this.searchForm)
			},
			getCateList() {
				this.$http.post(`erp/v1/goods_category/all`, {}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.cateList = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			getList() {
				this.loading = true;
				this.$http.post(`/erp/v1/order/lst_goods`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.tableData = data.rows
						this.total = data.total
					} else {
						this.$message.error(msg);
					}
				});
			},
			getCurrentDateTime() {
				const now = new Date();
				const year = now.getFullYear();
				const month = this.padNumber(now.getMonth() + 1); // 月份是从0开始的
				const day = this.padNumber(now.getDate());
				const hours = this.padNumber(now.getHours());
				const minutes = this.padNumber(now.getMinutes());
				const seconds = this.padNumber(now.getSeconds());
				return (
					year +
					'-' +
					month +
					'-' +
					day +
					' ' +
					hours +
					':' +
					minutes +
					':' +
					seconds
				);
			},
			padNumber(num) {
				return num < 10 ? '0' + num : num;
			},
			// 获取当前年月日
			getCurrentDate() {
				const today = new Date();
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			// 仓库
			getWarehouseList() {
				this.$http.post(`erp/v1/warehouse/all`).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.warehouseOptions = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 导出
			handleExport() {
				this.loading = true
				this.$http.post(`/erp/v1/order/summary_no_delivery`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm,
					export: 1
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url, '_self')
					} else {
						this.$message.error(msg);
					}
				});
			},
			handleExportWarehouse() {
				this.loading = true
				this.$http.post(`/erp/v1/order/summary_warehouse_no_delivery`, {
					...this.searchForm,
					export: 1
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url, '_self')
					} else {
						this.$message.error(msg);
					}
				});
			},
			handleExportContacts(sort) {
				this.loading = true
				this.$http.post(`/erp/v1/order/summary_contacts_no_delivery`, {
					...this.searchForm,
					export: 1,
					export_sort: sort
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url, '_self')
					} else {
						this.$message.error(msg);
					}
				});
			}

		},
	}
</script>

<style lang="scss" scoped></style>